export const changeVariant = (state, index, variant) => {
  state.accessoriesInfoList[index].selected_variant = _.cloneDeep(variant);
  if (state.accessoriesInfoList[index].selected) {
    const foundIndex = state.accessories.findIndex((accessory) =>
      (accessory.product_id === state.accessoriesInfoList[index].id));
    state.accessories[foundIndex].variant_id = variant.id;
  }
};

export const removeFromCart = (state) => {
  state.accessories.forEach((accessory) => {
    if (accessory.line_item_id) {
      state.accessoriesToDestroy.push(accessory.line_item_id);
    }

    const foundIndex = state.accessoriesInfoList.findIndex((info) => info.id === accessory.product_id);
    state.accessoriesInfoList[foundIndex].selected = false;
  });
  state.accessories = [];
};

export const removeAccessoryFromCart = (state, product_id) => {
  const foundIndex = state.accessories.findIndex((accessory) => accessory.product_id === product_id);
  const foundInfoIndex = state.accessoriesInfoList.findIndex((info) => info.id === product_id);
  state.accessoriesInfoList[foundInfoIndex].selected = false;

  if (state.accessories[foundIndex].line_item_id) {
    state.accessoriesToDestroy.push(state.accessories[foundIndex].line_item_id);
  }

  state.accessories = state.accessories.filter((accessory) => accessory.product_id !== product_id);
};

export const selectAccessory = (state, index) => {
  const accessory = state.accessoriesInfoList[index];
  const selected = !accessory.selected;
  accessory.selected = selected;

  if (!selected) {
    const foundIndex = state.accessories.findIndex((acc) => acc.product_id === accessory.id);

    if (state.accessories[foundIndex].line_item_id) {
      state.accessoriesToDestroy.push(state.accessories[foundIndex].line_item_id);
    }

    state.accessories = state.accessories.filter((acc) => acc.product_id !== accessory.id);
    return;
  }

  state.accessories.push({
    product_id: accessory.id,
    variant_id: accessory.selected_variant.id,
    quantity: accessory.quantity,
    price: accessory.selected_variant.price,
    line_item_id: null,
  });
};

export const changeQty = (state, index, qty) => {
  const foundIndex = state.accessories.findIndex((accessory) =>
    (accessory.product_id === state.accessoriesInfoList[index].id));

  if (qty !== null && qty !== undefined && qty !== '' && qty > 0) {
    state.accessoriesInfoList[index].quantity = qty;

    // If the accesory is not selected, but the quantity is greater than 1, then select it
    if (state.accessoriesInfoList[index].selected) {
      state.accessories[foundIndex].quantity = qty;
    } else if (qty > 1) {
      selectAccessory(state, index);
    }
  } else {
    state.accessoriesInfoList[index].quantity = 1;
    state.accessories[foundIndex].quantity = 1;
  }
};

export const isPasteProduct = (product) => {
  const pasteProducts = [
    'm8-sac305-t4-no-clean-lead-free-solder-paste',
    'm8-sn63-pb37-t4-no-clean-solder-paste',
    'ws488-t4-water-soluble-solder-paste',
    'ws488-t4-water-soluble-lead-free-solder-paste',
  ];

  return pasteProducts.includes(product.slug);
};
